import { Helmet } from 'react-helmet'

import { OnboardingBannerSlot } from '@/components/OnboardingBannerSlot'
import { useCaiDocked } from '@/components/sidebar'
import { SkeletonRows } from '@/components/ui/skeleton'
import { AskCai } from '../../../components/AskCai/AskCai'
import { cn } from '../../../lib/utils'
import { isOrgAdmin, useCurrentUser, worksFromQuotesPage } from '../../../models/user'
import { InsurancePolicy } from './Insurance/InsurancePolicy'

/**
 * Coverage the customer actually holds. Offers still being shopped live on the quotes
 * page, so until something is bound this tab says so rather than showing them again.
 */
export function Insurance() {
  const { user } = useCurrentUser({ enabled: true })
  const caiDocked = useCaiDocked()
  const policies = user?.currentOrg.insurancePolicies ?? []
  const hasPolicies = policies.length > 0

  if (!user) {
    return <SkeletonRows rows={3} />
  }

  const showsAskCai = !worksFromQuotesPage(user.currentOrg) && !caiDocked

  return (
    <>
      <Helmet>
        <title>Insurance</title>
      </Helmet>
      <h1 className="text-ink mb-4 text-2xl font-bold tracking-[-0.01em]">Insurance</h1>
      <OnboardingBannerSlot className="mb-6" />
      {/* Two columns with policies, AskCai on the right; one column so it sits under the line. */}
      <div className={cn('grid grid-cols-1 gap-6', hasPolicies && showsAskCai && 'lg:grid-cols-[5fr_3fr]')}>
        <div className="flex flex-col gap-10">
          {hasPolicies ? (
            <div>
              <h2 className="mb-4 text-2xl font-bold">My policies</h2>
              <div className="flex flex-col gap-8">
                {policies.map((policy) => (
                  <InsurancePolicy key={policy.id} policy={policy} canViewDocuments={isOrgAdmin(user)} />
                ))}
              </div>
            </div>
          ) : (
            <p className="text-ink-400 mx-auto max-w-xl py-16 text-center text-xl leading-relaxed font-semibold">
              Your insurance will show up here once your coverage starts.
            </p>
          )}
        </div>
        {/* mt-12 clears the h2 above, so AskCai's top edge meets the first card's. */}
        {showsAskCai && (
          <div className={hasPolicies ? 'mt-12' : 'mt-4 max-w-2xl'}>
            <AskCai />
          </div>
        )}
      </div>
    </>
  )
}
